import { render, staticRenderFns } from "./spellCard.vue?vue&type=template&id=b7a39454&scoped=true&"
import script from "./spellCard.vue?vue&type=script&lang=js&"
export * from "./spellCard.vue?vue&type=script&lang=js&"
import style0 from "./spellCard.vue?vue&type=style&index=0&id=b7a39454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a39454",
  null
  
)

export default component.exports